import { Model } from "vue-mc";

export class Perfil extends Model {
  defaults() {
    return {
      clave: null
      , nombre: ""
      , descripcion: ""
    };
  }

  mutations() {
    return {
      id: (id) => id
      , nombre: (nombre) => nombre
      , descripcion: (descripcion) => descripcion
    };
  }

  validation() {
    return {};
  }

  options() {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/models/seguridad/perfil.js